export default __webpack_public_path__ + "static/media/CollectionCards.dcd2f99d.png";